import { useQuery } from '@tanstack/react-query';
import { useSearch } from '@tanstack/react-router';
import { useEffect } from 'react';
import { tenantsQuery } from '@/api/tenants';
import type { Tenant } from '@/api/types';
import { safeStorage } from '@/lib/storage';

const KEY = 'coreai.tenant';

/**
 * Tenant "actual" del contexto: `?tenant=` en la URL > último elegido (localStorage) > primero de la lista.
 * Solo se persiste el id (preferencia de UI, no un secreto).
 */
export function useCurrentTenant() {
  const query = useQuery(tenantsQuery);
  const search = useSearch({ strict: false }) as { tenant?: string };
  const tenants = query.data ?? [];
  const fromUrl = search.tenant ? tenants.find((t) => t.id === search.tenant) : undefined;
  const stored = safeStorage.get(KEY);
  const fromStore = stored ? tenants.find((t) => t.id === stored) : undefined;
  const tenant: Tenant | undefined = fromUrl ?? fromStore ?? tenants[0];

  useEffect(() => {
    if (fromUrl) safeStorage.set(KEY, fromUrl.id);
  }, [fromUrl]);

  return {
    tenant,
    tenantId: tenant?.id ?? null,
    tenants,
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error,
    refetch: query.refetch,
  };
}

export const rememberTenant = (id: string) => safeStorage.set(KEY, id);
